import Lookup from 'src/componentes/select2';

const StatusRelatorioAcompanhamento = (props) => {
  return (
    <Lookup
      labelKey="descricao"
      valueKey="id"
      url="/StatusRelatorioAcompanhamentoLookup"
      {...props}
    />
  );
};

export default StatusRelatorioAcompanhamento;
